<template>
    <v-app :lang="$i18n.locale">
        <v-container class="spacing-playground">
            <v-row class="form-margin-top">
                <v-col
                    cols="12"
                    sm="12"
                    md="7"
                    class="d-flex justify-md-end justify-sm-center"
                >
                    <v-card
                        max-width="690"
                        elevation="0"
                        style="border-radius: 10px"
                    >
                        <v-card-text class="py-5">
                            <v-row class="py-0 mt-6 mb-3">
                                <v-col
                                    cols="12"
                                    md="12"
                                    sm="12"
                                    class="d-flex justify-center"
                                >
                                    <v-img
                                        :src="
                                            require('@/assets/Group 92924.svg')
                                        "
                                        contain
                                        width="222.86"
                                        height="155.29"
                                    />
                                </v-col>
                                <v-col
                                    cols="12"
                                    md="12"
                                    sm="12"
                                    class="mt-1 d-flex justify-center"
                                >
                                    <div class="prompt-title-page">
                                        {{ $t("message.step5.content.topic") }}
                                    </div>
                                </v-col>

                                <v-col
                                    cols="12"
                                    sm="12"
                                    md="12"
                                    class="form-subtitle-400 px-md-8 pt-0 d-flex justify-center col-width-content-scale"
                                >
                                    <p class="px-16 width-content-scale">
                                        {{
                                            $t("message.step5.content.message")
                                        }}
                                    </p>
                                </v-col>

                                <v-col
                                    cols="12"
                                    sm="12"
                                    md="12"
                                    class="
                                        px-md-8
                                        d-flex
                                        justify-md-center justify-sm-center
                                    "
                                >
                                    <div class="px-md-16 px-3">
                                        <v-row>
                                            <v-col>
                                                <div class="prompt-title">
                                                    {{
                                                        $t(
                                                            "message.step4.content.examinationResult"
                                                        )
                                                    }}
                                                </div>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col
                                                cols="12"
                                                sm="6"
                                                md="6"
                                                class="py-0"
                                            >
                                                <div
                                                    class="pa-0 prompt-caption"
                                                >
                                                    {{
                                                        $t(
                                                            "message.step5.content.name"
                                                        )
                                                    }}
                                                </div>
                                                <div
                                                    class="pa-0 mt-1 mb-3 submit__text"
                                                    v-if="
                                                        student?.student_detail
                                                    "
                                                >
                                                    {{ studentFullName }}
                                                </div>
                                            </v-col>
                                            <v-col
                                                cols="12"
                                                sm="6"
                                                md="6"
                                                class="py-0"
                                            >
                                                <div
                                                    class="pa-0 prompt-caption"
                                                >
                                                    {{
                                                        $t(
                                                            "message.step5.content.type"
                                                        )
                                                    }}
                                                </div>
                                                <div
                                                    class="pa-0 mt-1 mb-3 submit__text"
                                                >
                                                    {{ resultType }}
                                                </div>
                                            </v-col>
                                            <v-col
                                                cols="12"
                                                sm="6"
                                                md="6"
                                                class="py-0"
                                            >
                                                <div
                                                    class="pa-0 prompt-caption"
                                                >
                                                    {{
                                                        $t(
                                                            "message.step5.content.classroom"
                                                        )
                                                    }}
                                                </div>
                                                <div
                                                    class="pa-0 mt-1 submit__text"
                                                    v-if="student?.register_plan"
                                                >
                                                    {{
                                                        student?.register_plan
                                                            ?.student_year
                                                            ?.[`student_year_name_${locale}`]
                                                    }}
                                                </div>
                                            </v-col>
                                            <v-col
                                                cols="12"
                                                sm="6"
                                                md="6"
                                                class="py-0"
                                            >
                                                <div
                                                    class="pa-0 prompt-caption"
                                                >
                                                    {{
                                                        $t(
                                                            "message.step5.content.curriculum"
                                                        )
                                                    }}
                                                </div>
                                                <div
                                                    class="pa-0 mt-1 submit__text"
                                                    v-if="student?.register_plan"
                                                >
                                                    {{
                                                        student?.register_plan
                                                            ?.program
                                                            ?.[`program_name_${locale}`]
                                                    }}
                                                </div>
                                            </v-col>
                                            <v-col
                                                cols="8"
                                                sm="12"
                                                md="12"
                                                class="pt-9 pb-5"
                                            >
                                                <div
                                                    class="pa-0 submit__text"
                                                >
                                                    {{
                                                        $t(
                                                            "message.step3.content.question"
                                                        )
                                                    }}
                                                </div>
                                            </v-col>
                                        </v-row>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col
                    cols="12"
                    sm="12"
                    md="5"
                    id="step-sidebar"
                    class="ma-0 px-0"
                >
                    <StudentFormSummit
                        :step="step"
                        :registrationFormDetail="registrationFormDetail"
                        :student_id="student_id"
                        :success="success"
                        v-if="registrationFormDetail && student_id"
                        @loadingUpdate="loadingUpdate"
                    />
                </v-col>
                <v-col cols="12" sm="12" md="5" class="ma-0 px-0">
                    <div style="height: 480px" id="height-overflow"></div>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
import StudentFormSummit from "./StudentFormSummit";
import * as services from "@/services";
import i18n from '@/i18n';

export default {
    name: "StudentSummit",
    components: { StudentFormSummit },
    data: () => ({
        type: "pass",
        closeActive: true,
        student: {},
    }),
    props: {
        step: Number,
        student_id: Number,
        registrationFormDetail: Object,
        result_type: String,
        success: Boolean,
    },
    computed: {
        locale(){
            return i18n.locale
        },
        resultType() {
            if (this.result_type == "PASS") return i18n.t("message.step4.status.firstRound");
            else if (this.result_type == "RESERVED") return i18n.t("message.step4.status.reserveRound");
            else return "";
        },
        studentFullName(){
            return `${this.student?.student_detail?.prefix_id?.[`text_${this.locale}`]} ${this.student?.student_detail?.[`name_${this.locale}`]} ${this.student?.student_detail?.[`surname_${this.locale}`]}`
        }
    },
    methods: {
        async fetchInitStudentQuery() {
            try {
                this.$emit("loadingUpdate", 1);
                const body = {
                    token: localStorage.getItem("token"),
                    query: {
                        selects: {
                            id: true,
                            student_detail: {
                                prefix_id: {
                                    text_th: true,
                                    text_en: true,
                                },
                                name_th: true,
                                surname_th: true,
                                name_en: true,
                                surname_en: true,
                            },
                            register_plan: true,
                        },
                        relations: {
                            student_detail: {
                                prefix_id: true,
                            },
                            register_plan: {
                                program: true,
                                student_year: true,
                            },
                        },
                    },
                };
                const {
                    data: { data },
                } = await services.getStudentWithQuery(body);
                this.student = data.student;
            } catch (err) {
                console.log(err);
            } finally {
                this.$emit("loadingUpdate", -1);
            }
        },
        loadingUpdate(value) {
            this.$emit("loadingUpdate", value);
        },
    },
    created() {
        this.fetchInitStudentQuery();
    },
};
</script>

<style scoped lang="scss">
.form-label{
    font-size: 18px;
}

.width-content-scale{
    width:500px;
}

@media only screen and (max-width: 600px) {
    .width-content-scale{
        width:100%;
        padding-left: 0px !important;
        padding-right: 0px !important;
    }
    .col-width-content-scale{
        padding-left: 40px !important;
        padding-right: 40px !important;
    }
}

.submit__text{
    color: #37323c;
    font-family: 'Sarabun';
    font-size: 18px;
    .v-application[lang="en"] & {
        font-family: "inter", sans-serif !important;
    }
}

</style>